import { FC, useCallback } from 'react';
import Icon from '../icon';
import { PrivateModelModel } from '@/lib/models/private-model/private-model.model';
import ModelIcon from '../model-icon';
import { EntityLink } from '../entity-link';
import useDrawer from '@/hooks/use-drawer.hook';
import { useNavigate } from '@tanstack/react-router';
import { EntityLinkAction, EntityLinkVariant } from '../entity-link/helpers';
import { getModelIcon } from '../model-icon/helpers';
import { capitalize } from 'lodash';

interface Props {
  model: PrivateModelModel;
  showProviderModelId?: boolean;
  variant?: EntityLinkVariant;
  action?: EntityLinkAction;
}

const PrivateModelLink: FC<Props> = ({
  model,
  action = 'drawer',
  showProviderModelId = false,
  variant = 'text',
}) => {
  const { id, modelId, niceModelId, name, status, provider } = model;
  const hasIcon = !!getModelIcon(modelId);
  const navigate = useNavigate();
  const { openDrawer } = useDrawer();

  // Handle navigation
  const handleClick = useCallback(() => {
    if (action === 'drawer') {
      openDrawer('private-model', { id });
      return;
    }

    navigate({
      to: '/wais/private-models',
      search: { drawer: 'private-model', dp_id: id },
    });
  }, [id, navigate, openDrawer, action]);

  const hasClick = action !== 'none';
  const subtext = provider ? `${capitalize(provider)} — ${niceModelId}` : niceModelId;

  return (
    <EntityLink
      title={name}
      status={status}
      image={
        hasIcon ? (
          <ModelIcon modelId={modelId} size="small" />
        ) : (
          <Icon name="question-mark" color="grey" />
        )
      }
      variant={variant}
      onClick={hasClick ? handleClick : undefined}
      subtext={showProviderModelId ? subtext : undefined}
    />
  );
};

export default PrivateModelLink;
